import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';
import { BaseContainerProps } from '@appTypes/baseContainerProps';

export const StyledColorSection = styled.div<{ $isInViewport: boolean } & BaseContainerProps>`
  width: 100%;

  &:last-child {
    .TextAndImageBlock,
    .ImageLinksBlock,
    .Timeline,
    .NavigationLinksBlock {
      margin-bottom: 0;

      @media (max-width: ${breakpoints.s}) {
        margin-bottom: 0;
      }
    }
  }
`;
